export type LeagueStatus = 'setup' | 'active' | 'completed';

export interface League {
  id: string;
  name: string;
  description?: string;
  logoUrl?: string;
  status: LeagueStatus;
  pointSystem: number[];
  isPublic?: boolean;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
}
